
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  outline: none;
  cursor: pointer;
  display: inline-flex;
  position: relative;
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host ::slotted(*) {
  margin-left: 8px;
}
:host .slh-radio {
  display: inline-flex;
}
:host input {
  z-index: 1;
  opacity: 0.0001;
  width: 0;
  height: 0;
  position: absolute;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
}
:host .icon-wrapper {
  position: relative;
  z-index: 2;
  display: inline-flex;
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .icon-wrapper:hover {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host input:checked:not([disabled], [readonly]) ~ .icon-wrapper,
:host input[checked]:not([disabled], [readonly]) ~ .icon-wrapper {
  fill: var(--slh-color-primary, #3B87D4);
}
:host input:checked:not([disabled], [readonly]) ~ .icon-wrapper:hover,
:host input[checked]:not([disabled], [readonly]) ~ .icon-wrapper:hover {
  fill: var(--slh-color-primary-darken, #2867A2);
}
:host input:disabled ~ .icon-wrapper,
:host input[disabled] ~ .icon-wrapper {
  cursor: not-allowed;
  fill: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host input[readonly] ~ .icon-wrapper {
  fill: var(--slh-color-neutral-shade-20, #EBEEF4);
}

:host([error]) .icon-wrapper,
:host([error]) input:checked:not([disabled], [readonly]) ~ .icon-wrapper,
:host([error]) input[checked]:not([disabled], [readonly]) ~ .icon-wrapper {
  fill: var(--slh-color-error, #FF7E70);
}
:host([error]) .icon-wrapper:hover,
:host([error]) input:checked:not([disabled], [readonly]) ~ .icon-wrapper:hover,
:host([error]) input[checked]:not([disabled], [readonly]) ~ .icon-wrapper:hover {
  fill: var(--slh-color-error-darken, #FF5C5C);
}

:host(:focus):host([error]) input:checked:not([disabled], [readonly]) ~ .icon-wrapper,
:host(:focus):host([error]) input[checked]:not([disabled], [readonly]) ~ .icon-wrapper {
  filter: drop-shadow(0px 2px 2px var(--slh-color-error-shade-40, #FFDBD6));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-error-shade-40, #FFDBD6));
}

:host([disabled]) {
  pointer-events: none;
}

:host(:focus) input:not([disabled]) ~ .icon-wrapper {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
}
:host(:focus) input:checked:not([disabled], [readonly]) ~ .icon-wrapper,
:host(:focus) input[checked]:not([disabled], [readonly]) ~ .icon-wrapper {
  filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-primary-shade-60, #89B7E5));
}

:host(:focus-visible) input:not([disabled]) ~ .icon-wrapper {
  position: relative;
}
:host(:focus-visible) input:not([disabled]) ~ .icon-wrapper:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: -2px;
  left: -2px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 50%;
}
`;
